import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { CartProvider } from "./context/CartContext";
import { ConfirmProvider } from "./components/ConfirmProvider";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import KosherFoodPage from "./pages/KosherFoodPage";
import ShabbatPage from "./pages/ShabbatPage";
import ContactPage from "./pages/ContactPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import AdminPage from "./pages/AdminPage";
import HotelsPage from "./pages/HotelsPage";
import AttractionsPage from "./pages/AttractionsPage";
import OrderTrackPage from "./pages/OrderTrackPage";

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <ConfirmProvider>
        <div className="App">
          <BrowserRouter>
            <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/kosher-food" element={<KosherFoodPage />} />
              <Route path="/shabbat" element={<ShabbatPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/payment-success" element={<PaymentSuccessPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/order/:id" element={<OrderTrackPage />} />
              <Route path="/hotels" element={<HotelsPage />} />
              <Route path="/attractions" element={<AttractionsPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
        </ConfirmProvider>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
